var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tags-container" }, [
    _c("select", {
      staticClass: "single selectize selectize-bordered selectized",
      class: _vm.multiple ? "selectize-multiple" : "selectize-single",
      attrs: { name: _vm.selectedTagsInputName, multiple: _vm.multiple },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }